export default (props) => (
  /**
   * Ícone de olho riscado com cor de preenchimento parametrizada
   * Utilizado para exibir a camada e representa uma camada ocultada.
   */
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.79997 9.35912C2.98857 7.91544 1.54395 6.15637 1.54395 5.70361C1.54395 5.25086 2.98857 3.49179 4.79997 2.04811C6.42935 0.749487 8.35551 0.203613 9.79395 0.203613C11.2324 0.203613 13.1585 0.749487 14.7879 2.04811C16.5993 3.49179 18.0439 5.25086 18.0439 5.70361C18.0439 6.15637 16.5993 7.91544 14.7879 9.35912C13.1585 10.6577 11.2324 11.2036 9.79395 11.2036C8.35551 11.2036 6.42935 10.6577 4.79997 9.35912ZM16.0569 5.14887C15.476 4.47972 14.7148 3.74813 13.9309 3.12337C12.6788 2.12541 11.0958 1.57861 9.79395 1.57861C8.49209 1.57861 6.9091 2.12541 5.65696 3.12337C4.87307 3.74813 4.11191 4.47972 3.53099 5.14887C3.35407 5.35265 3.20226 5.54144 3.0833 5.70361C3.20226 5.86579 3.35407 6.05457 3.53099 6.25836C4.11191 6.92751 4.87307 7.6591 5.65696 8.28386C6.9091 9.28181 8.49209 9.82861 9.79395 9.82861C11.0958 9.82861 12.6788 9.28181 13.9309 8.28386C14.7148 7.6591 15.476 6.92751 16.0569 6.25836C16.2338 6.05457 16.3856 5.86579 16.5046 5.70361C16.3856 5.54144 16.2338 5.35265 16.0569 5.14887ZM9.79395 7.76611C8.65486 7.76611 7.73145 6.8427 7.73145 5.70361C7.73145 4.56453 8.65486 3.64111 9.79395 3.64111C10.933 3.64111 11.8564 4.56453 11.8564 5.70361C11.8564 6.8427 10.933 7.76611 9.79395 7.76611ZM9.79395 6.39111C10.1736 6.39111 10.4814 6.08331 10.4814 5.70361C10.4814 5.32392 10.1736 5.01611 9.79395 5.01611C9.41425 5.01611 9.10645 5.32392 9.10645 5.70361C9.10645 6.08331 9.41425 6.39111 9.79395 6.39111Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <line
      x1="0.665636"
      y1="10.3038"
      x2="18.7635"
      y2="1.29006"
      stroke={props.stroke ? props.stroke : 'currentColor'}
      strokeWidth="1.5"
    />
  </svg>
);
